import { useTranslation } from "react-i18next";
import { PlatformBranding } from "@/partner/features/platformBranding";
import { Meta } from "@/shared/components";

export const PlatformBrandingPage = () => {
  const { t } = useTranslation();

  return (
    <>
      <Meta title={t("platformBranding.pageTitle")} pageType="Partner" />
      <PlatformBranding />
    </>
  );
};
